import React from "react";
/* css comes in adminMember.css */
import Form from "react-bootstrap/Form";
import { getInitial } from "../../../../../utils/Engagement";
import { IP } from "../../../../../internalServer"

function IndividualsMemberForStudents({
  student,
  inEditingMode,
  setDeletingAllMembersDetails,
  deletingAllMembersDetails,
}) {
  const { deletingStudents } = deletingAllMembersDetails;
  const handleDeleteMember = () => {
    if (deletingStudents.includes(student.id)) {
      const newStudentsList = deletingStudents.filter((a) => a !== student.id);
      setDeletingAllMembersDetails((prevState) => ({
        ...prevState,
        deletingStudents: newStudentsList,
      }));
    } else {
      setDeletingAllMembersDetails((prev) => ({
        ...prev,
        deletingStudents: [...prev.deletingStudents, student.id],
      }));
    }
  };
  return (
    <>
      <div className="col-12 p-0 d-flex align-items-center">
        <div className="col-8 p-0 mt-3 gap-2 d-flex align-items-center">
          <div className=" d-flex align-items-center justify-content-center">
            {
              student?.role === "member" ?
                < img
                  src={
                    student?.student?.profilePicture
                      ? IP + student?.student?.profilePicture.replace(/^\./, "")
                      : student?.student?.gender === "M"
                        ? student?.student?.avatarProfile ? '/images/Boys/' + student?.student?.avatarProfile + '.webp'
                          : "/images/Student_boy_pic.png"
                        : student?.student?.gender === "F"
                          ? student?.student?.avatarProfile ? '/images/Girls/' + student?.student?.avatarProfile + '.webp'
                            : "/images/Student_girl_pic.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer" }}
                  key={student?.student?.profilePicture}
                  onError={(e) => {
                    if (student?.student?.gender === "M") {
                      e.target.src = student?.student?.avatarProfile ? '/images/Boys/' + student?.student?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                    } else if (student?.student?.gender === "F") {
                      e.target.src = student?.student?.avatarProfile ? '/images/Girls/' + student?.student?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                    } else {
                      e.target.src = "/images/default image.png"
                    }
                  }}
                /> : <img style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer", marginRight: "10px" }} src="/images/default image.png" alt="" />
            }
          </div>
          <span>{student?.student?.name}</span>
        </div>

        <div className="mt-3 gap-3 d-flex">
          <span className="roleStyle">MEMBER</span>
          {inEditingMode && (
            <>
              {!deletingStudents.includes(student.id) ? (
                <img
                  onClick={handleDeleteMember}
                  src="/images/Dustbin.svg"
                  alt=""
                />
              ) : (
                <img
                  onClick={handleDeleteMember}
                  src="/images/redDustbin.svg"
                  alt=""
                />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default IndividualsMemberForStudents;
